import { commonEnvs } from "@/config/env";
import {
  Experiment as NodeExperiment,
  type Variant,
} from "@amplitude/experiment-node-server";

type AmplitudeExperimentIdentity = {
  deviceId?: string;
  userId?: string;
};

export type Experiments = keyof typeof ExperimentsFlags extends never
  ? Record<string, Variant | undefined>
  : Record<ExperimentsFlags, Variant>;

export enum ExperimentsFlags {
  AboutHeaderLink = "about-header-link",
  ShowCart = "commerce-catalogo-carrinho",
  CreatePaymentLink = "commerce-catalogo-link-de-pagamento",
  Checkout = "commerce-catalogo-checkout",
  Stock = "commerce-catalogo-estoque",
  OpeningHours = "commerce-catalogo-horarios-de-funcionamento",
}

export enum ExperimentsVariants {
  Default = "default",
  Off = "off",
  On = "on",
  Control = "control",
  Treatment = "treatment",
}

export const experimentsDefault: Experiments = {
  [ExperimentsFlags.AboutHeaderLink]: { key: ExperimentsVariants.Off },
  [ExperimentsFlags.ShowCart]: { key: ExperimentsVariants.Off },
  [ExperimentsFlags.CreatePaymentLink]: { key: ExperimentsVariants.Off },
  [ExperimentsFlags.Checkout]: { key: ExperimentsVariants.Off },
  [ExperimentsFlags.Stock]: { key: ExperimentsVariants.Off },
  [ExperimentsFlags.OpeningHours]: { key: ExperimentsVariants.Off },
};

export async function getExperiments({
  deviceId,
  userId,
}: AmplitudeExperimentIdentity) {
  if (
    commonEnvs.ANALITICA_ENABLED &&
    deviceId &&
    typeof deviceId === "string" &&
    (userId === undefined || typeof userId === "string")
  ) {
    try {
      const experiment = NodeExperiment.initializeRemote(
        commonEnvs.KEY.EXPERIMENT.SERVER!
      );
      const experiments = await experiment.fetchV2({
        device_id: deviceId,
        user_id: userId,
      });

      return {
        ...experimentsDefault,
        ...experiments,
      };
    } catch {
      return experimentsDefault;
    }
  }

  return experimentsDefault;
}
